<template>
  <div class="table_container">
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <el-table-column label="往年均价" align="center">
        <el-table-column
          prop="years"
          label="年份"
          min-width="90px"
          align="center"
          class-name="disabled_column"
        />
        <el-table-column label="油价" min-width="90px" align="center">
          <el-table-column
            prop="gasoline80"
            label="汽油: 80# (单位sum) "
            min-width="160px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="editField === 'gasoline80' && editIndex === scope.$index"
                id="focusRef"
                v-model="scope.row.gasoline80"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row.gasoline80 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gasoline92"
            label="汽油: 92# (单位sum) "
            min-width="160px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="editField === 'gasoline92' && editIndex === scope.$index"
                id="focusRef"
                v-model="scope.row.gasoline92"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row.gasoline92 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gasoline95"
            label="汽油: 95# (单位sum) "
            min-width="160px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="editField === 'gasoline95' && editIndex === scope.$index"
                id="focusRef"
                v-model="scope.row.gasoline95"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row.gasoline95 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="diesel2"
            label="柴油: 标号2# (单位sum) "
            min-width="180px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="editField === 'diesel2' && editIndex === scope.$index"
                id="focusRef"
                v-model="scope.row.diesel2"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row.diesel2 }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="电价" min-width="90px" align="center">
          <el-table-column
            prop="electricPriceHouse"
            label="家用 (单位sum) "
            min-width="140px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="
                  editField === 'electricPriceHouse' &&
                    editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row.electricPriceHouse"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row.electricPriceHouse }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="electricPriceCommercial"
            label="商用 (单位sum) "
            min-width="140px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="
                  editField === 'electricPriceCommercial' &&
                    editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row.electricPriceCommercial"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row.electricPriceCommercial }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="气价" min-width="90px" align="center">
          <el-table-column
            prop="gasPriceHouse"
            label="家用 (单位sum) "
            min-width="140px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="
                  editField === 'gasPriceHouse' && editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row.gasPriceHouse"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row.gasPriceHouse }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gasPriceCar"
            label="车用 (单位sum) "
            min-width="140px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="editField === 'gasPriceCar' && editIndex === scope.$index"
                id="focusRef"
                v-model="scope.row.gasPriceCar"
                class="number_input"
                :controls="false"
                :precision="2"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row.gasPriceCar }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateBasePriceInfoApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data) {
      this.tableData = data || [
        { years: 2022 },
        { years: 2023 },
        { years: 2024 }
      ];
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      if (this.$route.query.operateType === "查看") return;
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // 保存
    async handleSave(params) {
      try {
        const submitData = {
          ...params,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateBasePriceInfoApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
